import { ReactNode, useMemo } from 'react';

import { WithSkeleton, WithSkeletonContext } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { breakpoints } from '~/src/features/_layout/Header/types';

import { SkeletonContainer } from './styled';

const getArray = (count: number) => Array.from({ length: count }, (_, i) => ({
    id: i,
    width: i % 2 ? '75%' : '100%',
}));

const createMobileSkeletonProps = () => ({
    containerWidth: '350px',
    height: '40px',
    counter: getArray(2),
});

const createDesktopSkeletonProps = () => ({
    containerWidth: '164px',
    height: '80px',
    counter: getArray(4),
});

interface IProps {
    isLoading: boolean,
    children: ReactNode,
}

const SkeletonComponent = ({ isLoading, children }: IProps) => {
    const isMobile = useMatchMediaByWidth(breakpoints.mMobile);
    const currentSkeletonProps = useMemo(() =>
            isMobile ? createMobileSkeletonProps() : createDesktopSkeletonProps(),
        [isMobile]);

    return (
        <WithSkeletonContext isLoading={isLoading}>
            <SkeletonContainer
                width={currentSkeletonProps.containerWidth}
                height={currentSkeletonProps.height}
                isLoading={isLoading}
            >
                {currentSkeletonProps.counter.map(({ id, width }) =>
                    // eslint-disable-next-line react/no-children-prop
                    <WithSkeleton key={id} width={width} height={'16px'} children={null}/>)}
            </SkeletonContainer>
            {children}
        </WithSkeletonContext>
    );
};
export default SkeletonComponent;
